import React, {useEffect, useState} from "react";
import {useSelector} from "react-redux";
import {useNavigate} from "react-router-dom";

import Page from "@/components/Page";
import Loading from "@/components/Loading";
import Breadcrumbs from "@/components/Breadcrumbs";
import MainActions from "@/components/MainActions";
import CardsList from "@/components/CardsList";

import {RosterAPI} from "@/api/roster";

import AddIcon from "@mui/icons-material/Add";

import {ERROR_OPERATION} from "@/utils/constants";

import "./index.scss";

function ManagerFootballTeamsPage(props) {
	const {handleNotification} = props;

	const navigate = useNavigate();
	const seasonId = useSelector((state) => state?.season?.id);

	const [loading, setLoading] = useState(false);
	const [teams, setTeams] = useState([]);

	const getTeams = async () => {
		setLoading(true);
		try {
			const response = await RosterAPI.list({seasonId});
			setTeams(response.filter((t) => !t.prospect));
		} catch (error) {
			handleNotification(ERROR_OPERATION, "error");
		} finally {
			setLoading(false);
		}
	};

	useEffect(() => {
		getTeams();
	}, []);

	const listConfiguration = {
		data: teams.sort(
			(a, b) => a.playerCategory.sorting - b.playerCategory.sorting,
		),
		onClick: (team) => navigate("/manager/teams/" + team.id),
	};

	const headerActions = [
		{
			icon: <AddIcon />,
			title: "Aggiungi",
			onClick: () => navigate("/manager/teams/new"),
		},
	];

	return (
		<Page>
			<Loading visible={loading} />
			<Breadcrumbs actions={<MainActions actions={headerActions} />} />
			<CardsList
				type="manager_football_team"
				breadcrumbs
				listConfiguration={listConfiguration}
			/>
		</Page>
	);
}

export default ManagerFootballTeamsPage;
